import React from 'react';
import CircleWithShadow from 'commonComponents/icons/CircleWithShadow/CircleWithShadow';
import classNames from 'classnames';
import styles from './SetOfCircleIcons.module.scss';

const SetOfCircleIcons = ({ icons, rendered, additionalClass }) => {
  const classes = classNames({
    [styles.SetOfCircleIcons]: true,
    [additionalClass]: !!additionalClass,
  });

  return (
    <div className={classes}>
      {icons &&
        icons.map((icon) => 
          <CircleWithShadow
            key={icon.name}
            rendered={rendered}
            { ...icon }
          />)}
    </div>
  );
};

export default SetOfCircleIcons;
